import { render, staticRenderFns } from "./SpecialParts.vue?vue&type=template&id=28cb98d4&lang=pug"
import script from "./SpecialParts.vue?vue&type=script&lang=js"
export * from "./SpecialParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports